import { AssetType } from '../../_utils';
import { BLOCKCHAINS } from '../../wallets/providers';
import { actionTypes } from '../_actions/wallet.action';

export interface IWalletState {
  chains: Chain[];
  userAssets: AssetType[];
  cctpAssets: MappedCCTPAssets;
  cctpUnifiedAssets: CCTPUnifiedAssets[];
}

const initialState: IWalletState = {
  chains: [],
  userAssets: [],
  cctpUnifiedAssets: [],
  cctpAssets: {}, //why it in wallet reducer?
};

export interface Chain {
  chainId: number;
  whChainId: string;
  tmc: string;
  name: BLOCKCHAINS;
}

export type MappedCCTPAssets = {[key: string]: CCTPAssets[]}

export interface CCTPAssets {
  chainId: number; //wh chain id
  address: string;
  unifiedChainId: number;
}

export interface CCTPUnifiedAssets {
  id: number;
  chainId: number;
  address: string;
  symbol: string;
}

const walletState = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SAVE_CHAINS: {
      return {
        ...state,
        chains: [...action.data],
      };
    }
    case actionTypes.SAVE_USER_ASSETS:
      return {
        ...state,
        userAssets: action.data,
      };
    case actionTypes.SAVE_CCTP_ASSETS: {
      return {
        ...state,
        cctpAssets: {...action.data},
      };
    }
    case actionTypes.SAVE_CCTP_UNIFIED_ASSETS: {
      return {
        ...state,
        cctpUnifiedAssets: [...action.data],
      };
    }
    default:
      return state;
  }
};

export default walletState;
